<template>
  <div class="sidebar-footer" :class="{ collapsed }">
    <n-menu :options="menuOptions" :collapsed="collapsed" :collapsed-width="collapsedWidth"
            @update:value="handleUpdateSidebarValue"/>
  </div>
</template>

<script lang="ts" setup>
import {computed, h, ref, toRefs} from "vue"
import {NMenu} from "naive-ui"
import {useThemeStore} from "@/stores/theme"
import {renderIcon} from "@/utils"
import {useAuthStore} from "@/stores/auth"

const authStore = useAuthStore()
const isSubsMissing = computed(() => authStore.getSubscriptionIsRequired() || authStore.getAccountRolePlayerFree())

const props = withDefaults(
    defineProps<{
      collapsed?: boolean
    }>(),
    {collapsed: false}
)
const {collapsed} = toRefs(props)

const BuyIcon = "carbon:shopping-cart"
const DocsIcon = "ion:book-outline"
const menuOptions = ref([
  {
    label: () =>
        h(
            "a",
            {
              href: "https://pinx-docs.vercel.app/",
              target: "_blank",
              rel: "noopenner noreferrer"
            },
            "Help"
        ),
    key: "documentation",
    icon: renderIcon(DocsIcon),
    show: false
  },
  {
    label: () =>
        h(
            "a",
            authStore.getUpgradeButtonLabel()
        ),
    key: "buy-now",
    icon: renderIcon(BuyIcon),
    show: isSubsMissing
  }
])

const themeStore = useThemeStore()

const collapsedWidth = computed<number>(() => themeStore.sidebar.closeWidth - 16)

async function goToShop() {
  if (!authStore.getSubscriptionIsRequired() && !authStore.getAccountRolePlayerFree()) return

  let missingSubs = authStore.getMissingSubscriptions()[0]?.[0]
  if (authStore.getAccountRolePlayerFree()) {
    missingSubs = "ROLE_PLAYER_PRO"
  }

  if (!missingSubs) return;

  const paymentUrl = await authStore.fetchPaymentUrl(missingSubs)
  if (!paymentUrl || paymentUrl.length < 4) return

  window.open(paymentUrl, "_blank")
}

function handleUpdateSidebarValue(key: string, item: MenuOption) {
  if (key === "buy-now") {
    goToShop()
  }
}
</script>

<style lang="scss" scoped>
.sidebar-footer {
  margin: 8px;
  background-color: var(--bg-body);
  border-radius: var(--border-radius);
  padding: 3px 0;
  transition: all 0.3s;

  :deep() {
    .n-menu {
      .n-menu-item-content.n-menu-item-content--selected::before {
        background-color: transparent !important;
      }
    }
  }
}
</style>
